export const isMail = (value) =>
  value.indexOf('@') !== -1 && value.split('@')[1].indexOf('.') !== -1;
